import React from "react";
import { Modal } from "reactstrap";
import { Loader } from "./Loader";
import { QRCodeCanvas } from "qrcode.react";

export const QrCodeModal = ({ visible, toggleModal, data }) => {
  // const [formSubmitDisabled, setFormSubmitDisabled] = useState(false)
  const modalSize = "sm";

  const downloadQrCode = (fileName) => {
    const canvas = document.getElementById("canvas");
    const dataUrl = canvas.toDataURL("image/png");
    // setDataImage(dataUrl);
    // console.log(dataUrl);
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = fileName+'.png';
    link.click();
  };

  return (
    <Modal
      size={modalSize}
      isOpen={visible}
      toggle={() => toggleModal()}
      keyboard={false}
      backdrop="static"
    >
      <Loader loading={false} transparent />
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          QR CODE
        </h5>
        <button
          type="button"
          onClick={() => toggleModal({})}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div id="modalBody" className="modal-body">
        <div
          style={{
            height: "auto",
            margin: "0 auto",
            // maxWidth: 64,
            width: "100%",
          }}
        >          
          <QRCodeCanvas
            id="canvas"
            size={256}
            style={{
              height: "auto",
              maxWidth: "100%",
              width: "100%",
            }}
            value={data ? data.qr_url : ""}
            includeMargin={true}
          />
         
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={()=>downloadQrCode(data.name)}
          className="btn btn-primary waves-effect"
          // data-dismiss="modal"
          // href={dataImage}
          // download={data? data.name + ".png" : "image.png"}
        >
          Download
        </button>
        <button
          type="button"
          onClick={() => toggleModal({})}
          className="btn btn-secondary waves-effect"
          data-dismiss="modal"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};
